/**
 * Mock Option Blocks and Option Block Subjects
 */

import type {
  CpOptionBlock,
  CpOptionBlockSubject,
  CpRotationGroup,
  CpRotationGroupSubject,
} from '../../../types/curriculum_planning';

const now = Date.now();

export const mockCpOptionBlocks: CpOptionBlock[] = [
  // Year 10 Option Blocks
  {
    id: 'ob-y10-a',
    name: 'Option Block A',
    code: 'Y10A',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    periodsPerCycle: 4,
    minSubjectsToChoose: 1,
    maxSubjectsToChoose: 1,
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'ob-y10-b',
    name: 'Option Block B',
    code: 'Y10B',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    periodsPerCycle: 4,
    minSubjectsToChoose: 1,
    maxSubjectsToChoose: 1,
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'ob-y10-c',
    name: 'Option Block C',
    code: 'Y10C',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    periodsPerCycle: 4,
    minSubjectsToChoose: 1,
    maxSubjectsToChoose: 1,
    displayOrder: 3,
    createdAt: now,
    updatedAt: now,
  },
  // Year 11 Option Blocks
  {
    id: 'ob-y11-a',
    name: 'Option Block A',
    code: 'Y11A',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    periodsPerCycle: 4,
    minSubjectsToChoose: 1,
    maxSubjectsToChoose: 1,
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'ob-y11-b',
    name: 'Option Block B',
    code: 'Y11B',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    periodsPerCycle: 4,
    minSubjectsToChoose: 1,
    maxSubjectsToChoose: 1,
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'ob-y11-c',
    name: 'Option Block C',
    code: 'Y11C',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    periodsPerCycle: 4,
    minSubjectsToChoose: 1,
    maxSubjectsToChoose: 1,
    displayOrder: 3,
    createdAt: now,
    updatedAt: now,
  },
];

export const mockCpOptionBlockSubjects: CpOptionBlockSubject[] = [
  // Year 10 Option Block A
  {
    id: 'obs-y10a-hist',
    optionBlockId: 'ob-y10-a',
    subjectId: 'subj-history',
    maxStudents: 28,
    teacherId: 'teacher-004',
    createdAt: now,
  },
  {
    id: 'obs-y10a-geog',
    optionBlockId: 'ob-y10-a',
    subjectId: 'subj-geography',
    maxStudents: 28,
    teacherId: 'teacher-005',
    createdAt: now,
  },
  {
    id: 'obs-y10a-art',
    optionBlockId: 'ob-y10-a',
    subjectId: 'subj-art',
    maxStudents: 24,
    teacherId: 'teacher-008',
    createdAt: now,
  },
  // Year 10 Option Block B
  {
    id: 'obs-y10b-french',
    optionBlockId: 'ob-y10-b',
    subjectId: 'subj-mfl-french',
    maxStudents: 28,
    teacherId: 'teacher-007',
    createdAt: now,
  },
  {
    id: 'obs-y10b-spanish',
    optionBlockId: 'ob-y10-b',
    subjectId: 'subj-mfl-spanish',
    maxStudents: 28,
    createdAt: now,
  },
  {
    id: 'obs-y10b-music',
    optionBlockId: 'ob-y10-b',
    subjectId: 'subj-music',
    maxStudents: 24,
    teacherId: 'teacher-010',
    createdAt: now,
  },
  // Year 10 Option Block C
  {
    id: 'obs-y10c-computing',
    optionBlockId: 'ob-y10-c',
    subjectId: 'subj-computing',
    maxStudents: 28,
    teacherId: 'teacher-009',
    createdAt: now,
  },
  {
    id: 'obs-y10c-business',
    optionBlockId: 'ob-y10-c',
    subjectId: 'subj-business',
    maxStudents: 28,
    createdAt: now,
  },
  {
    id: 'obs-y10c-drama',
    optionBlockId: 'ob-y10-c',
    subjectId: 'subj-drama',
    maxStudents: 24,
    createdAt: now,
  },
  // Year 11 Option Block A
  {
    id: 'obs-y11a-hist',
    optionBlockId: 'ob-y11-a',
    subjectId: 'subj-history',
    maxStudents: 28,
    teacherId: 'teacher-004',
    createdAt: now,
  },
  {
    id: 'obs-y11a-geog',
    optionBlockId: 'ob-y11-a',
    subjectId: 'subj-geography',
    maxStudents: 28,
    teacherId: 'teacher-005',
    createdAt: now,
  },
  {
    id: 'obs-y11a-art',
    optionBlockId: 'ob-y11-a',
    subjectId: 'subj-art',
    maxStudents: 24,
    teacherId: 'teacher-008',
    createdAt: now,
  },
  // Year 11 Option Block B
  {
    id: 'obs-y11b-french',
    optionBlockId: 'ob-y11-b',
    subjectId: 'subj-mfl-french',
    maxStudents: 28,
    teacherId: 'teacher-007',
    createdAt: now,
  },
  {
    id: 'obs-y11b-music',
    optionBlockId: 'ob-y11-b',
    subjectId: 'subj-music',
    maxStudents: 24,
    teacherId: 'teacher-010',
    createdAt: now,
  },
  // Year 11 Option Block C
  {
    id: 'obs-y11c-computing',
    optionBlockId: 'ob-y11-c',
    subjectId: 'subj-computing',
    maxStudents: 28,
    teacherId: 'teacher-009',
    createdAt: now,
  },
  {
    id: 'obs-y11c-business',
    optionBlockId: 'ob-y11-c',
    subjectId: 'subj-business',
    maxStudents: 28,
    createdAt: now,
  },
];

// Rotation Groups (for KS3 subjects that rotate)
export const mockCpRotationGroups: CpRotationGroup[] = [
  {
    id: 'rg-y7-creative',
    name: 'Y7 Creative Arts Rotation',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    rotationPattern: 'termly',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'rg-y8-creative',
    name: 'Y8 Creative Arts Rotation',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    rotationPattern: 'termly',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'rg-y9-creative',
    name: 'Y9 Creative Arts Rotation',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    rotationPattern: 'termly',
    createdAt: now,
    updatedAt: now,
  },
];

export const mockCpRotationGroupSubjects: CpRotationGroupSubject[] = [
  // Y7 Creative Rotation
  {
    id: 'rgs-y7-art',
    rotationGroupId: 'rg-y7-creative',
    subjectId: 'subj-art',
    sequenceOrder: 1,
    createdAt: now,
  },
  {
    id: 'rgs-y7-music',
    rotationGroupId: 'rg-y7-creative',
    subjectId: 'subj-music',
    sequenceOrder: 2,
    createdAt: now,
  },
  {
    id: 'rgs-y7-drama',
    rotationGroupId: 'rg-y7-creative',
    subjectId: 'subj-drama',
    sequenceOrder: 3,
    createdAt: now,
  },
  // Y8 Creative Rotation
  {
    id: 'rgs-y8-art',
    rotationGroupId: 'rg-y8-creative',
    subjectId: 'subj-art',
    sequenceOrder: 1,
    createdAt: now,
  },
  {
    id: 'rgs-y8-music',
    rotationGroupId: 'rg-y8-creative',
    subjectId: 'subj-music',
    sequenceOrder: 2,
    createdAt: now,
  },
  {
    id: 'rgs-y8-drama',
    rotationGroupId: 'rg-y8-creative',
    subjectId: 'subj-drama',
    sequenceOrder: 3,
    createdAt: now,
  },
  // Y9 Creative Rotation
  {
    id: 'rgs-y9-art',
    rotationGroupId: 'rg-y9-creative',
    subjectId: 'subj-art',
    sequenceOrder: 1,
    createdAt: now,
  },
  {
    id: 'rgs-y9-music',
    rotationGroupId: 'rg-y9-creative',
    subjectId: 'subj-music',
    sequenceOrder: 2,
    createdAt: now,
  },
  {
    id: 'rgs-y9-drama',
    rotationGroupId: 'rg-y9-creative',
    subjectId: 'subj-drama',
    sequenceOrder: 3,
    createdAt: now,
  },
];
